import { Box, Grid, makeStyles } from "@material-ui/core"
import React from "react"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import { jobFiltersStateVar } from "../../data"
import { isArrayOddLength, isLastInArray, useMountAwareReactiveVar } from "../../utils"
import { JobsCompletionChartCard } from "./JobsCompletionChartCard"

const useStyles = makeStyles(() => ({
  gridItem: {
    width: "100%",
    cursor: "pointer",
  },
}))

const JobsGroupsCompletionChartCards = ({ jobs: allJobs }) => {
  const classes = useStyles()
  const history = useHistory()
  const jobsFiltersStore = useMountAwareReactiveVar(jobFiltersStateVar)

  const handleClick = (groupId) => {
    jobFiltersStateVar({
      ...jobsFiltersStore,
      tab: "others",
      toGroups: [groupId],
    })
    history.push("/jobs")
  }

  if (!allJobs) return null

  // split jobs into groups
  let groupsIds = []
  allJobs.forEach((job) => job.groups.forEach((group) => groupsIds.push(group.id)))
  groupsIds = [...new Set(groupsIds)]

  return (
    <Grid container spacing={2}>
      {groupsIds.map((groupId, index) => {
        const groupJobs = allJobs.filter((job) => job.groups.some((group) => group.id === groupId))
        const { name } = groupJobs[0].groups.find((group) => group.id === groupId)
        const last = isLastInArray(groupsIds, index)
        const oddLength = isArrayOddLength(groupsIds)
        const evenAndSecondLast = !oddLength && index === groupsIds.length - 2
        const full = last && oddLength

        return (
          <Grid key={groupId} item lg={full ? 12 : 6} sm={12} className={classes.gridItem}>
            <Box mb={last || evenAndSecondLast ? 0 : -1} onClick={() => handleClick(groupId)}>
              <JobsCompletionChartCard
                title={
                  <>
                    <strong>{name}</strong> completion rate for today
                  </>
                }
                jobs={groupJobs}
              />
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}

export { JobsGroupsCompletionChartCards }
